export default "__VITE_ASSET__4f2d31ee__"